module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sticky-navigation"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    directives: [{
      name: "scroll-spy-active",
      rawName: "v-scroll-spy-active",
      value: ({
        selector: "li>a"
      }),
      expression: "{selector: `li>a` }"
    }]
  }, _vm._l((_vm.navigationLinks), function(link, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (link.name),
        expression: "link.name"
      }],
      key: i
    }, [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: '#link-' + i,
          container: 'body',
        }),
        expression: "{ el: '#link-' + i, container: 'body',}"
      }],
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4406bc9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StickyNavigation.vue
// module id = 333
// module chunks = 0